import React from "react";
import { useNavigate } from "react-router-dom";
import astronaut from "../assets/astronaut.webp";
import greenBg from "../assets/green_bg.png";
import FunnelFooterWithLinks from "../components/FunnelFooterWithLinks";
import Navbar from "../components/Navbar";
import PromotionalBanner from "../components/PromotionalBanner";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="relative min-h-screen w-full overflow-hidden flex flex-col">
      <img
        src={greenBg}
        alt=""
        className="fixed inset-0 w-full h-full object-cover z-0"
        style={{ minHeight: "100vh" }}
      />
      <div className="relative flex flex-col flex-1 z-10">
        <PromotionalBanner />
        <Navbar />
        <div className="flex-1 flex flex-col items-center justify-center text-center">
          <div className="relative z-10 flex flex-col items-center justify-center py-16">
            <div className="w-full max-w-[416px] pb-6">
              <img src={astronaut} alt="Astronaut" />
            </div>

            <h1 className="text-2xl md:text-4xl font-bold text-white mb-4">
              Oops! The page you are looking for can not be found.
            </h1>
            <p className="text-white text-base md:text-lg mb-8 max-w-xl mx-auto">
              We find real job offers with your title and skillset. You can ask
              for more at your current job, or take the better offer.
            </p>
            <button
              className="bg-black text-white rounded-full px-8 py-3 font-semibold text-lg"
              onClick={() => navigate("/")}
            >
              Back to Home
            </button>
          </div>
        </div>
        <section className="relative p-4">
          <FunnelFooterWithLinks />
        </section>
      </div>
    </div>
  );
}
